module.exports = ".popup-content {\n  padding: 20px 0; }\n"